import { render, staticRenderFns } from "./mnMarketing.vue?vue&type=template&id=53e7bfb7"
import script from "./mnMarketing.vue?vue&type=script&lang=js"
export * from "./mnMarketing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports